import "core-js/modules/es.array.iterator";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import Axios from 'axios';
import merge from 'lodash.merge';
import { ApiClientRequestError, ApiClientResponseError } from '../api-client.errors';
var paramsRegex = /:(.+?)(?=\/|$)/g;
var multiSlashRegex = /\/+/g;

function trimDuplicatedSlashs(url) {
  return url.replace(multiSlashRegex, '/');
}

function createURL(origin, apiRoot, path) {
  try {
    return new URL(trimDuplicatedSlashs("".concat(apiRoot, "/").concat(path)), origin);
  } catch (err) {
    throw new ApiClientRequestError('malformed url');
  }
}

function createHeaders(tokens, tokenName) {
  if (!tokenName) return;
  if (!tokens) throw new ApiClientRequestError("tokens is not provided");
  var token = tokens[tokenName];
  if (!token) throw new ApiClientRequestError("".concat(tokenName, " is not provided"));
  return {
    Authorization: "Bearer ".concat(token)
  };
}

function replaceParams(url, params) {
  url.pathname = url.pathname.replace(paramsRegex, (_, key) => encodeURIComponent(params[key]));
}

function appendQuery(url, query) {
  Object.keys(query).forEach(key => {
    if (query[key] !== undefined) url.searchParams.append(key, query[key]);
  });
}

export function createApiClientMethod(config, definition) {
  var {
    method,
    path,
    tokenName,
    prepare
  } = definition;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (tokens) {
      var requestConfig;

      try {
        var {
          ORIGIN,
          API_ROOT
        } = config;

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var {
          params,
          body,
          query,
          headers: _headers,
          requestConfig: _requestConfig
        } = prepare({
          config
        }, ...args);
        var url = createURL(ORIGIN, API_ROOT, path);
        var headers = createHeaders(tokens, tokenName);
        if (params) replaceParams(url, params);
        if (query) appendQuery(url, query);
        requestConfig = _objectSpread({
          method,
          url: url.href,
          data: body,
          maxRedirects: 0
        }, headers ? {
          headers
        } : undefined);
        if (_headers) requestConfig = merge(requestConfig, {
          headers: _headers
        });
        if (_requestConfig) requestConfig = merge(requestConfig, _requestConfig);
      } catch (err) {
        if (err instanceof ApiClientRequestError) throw err;
        throw new ApiClientRequestError(err.message);
      }

      try {
        var response = yield Axios.request(requestConfig);
        if (response.status === 302) return {
          location: response.headers['Location']
        };
        return response.data;
      } catch (err) {
        throw new ApiClientResponseError(err);
      }
    });

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}